import React from 'react';
import { GraduationCap } from 'lucide-react';

export const UniversityPartners = () => {
  return (
    <section id="universities" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold">Global Recognition</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">University Pathways</h2>
          <p className="text-xl text-gray-600">OSSD opens doors to 500+ universities worldwide</p>
        </div>

        {/* Top Universities */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">University of Toronto</h4>
            <p className="text-sm text-gray-600">Toronto, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 20 Global</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">UBC</h4>
            <p className="text-sm text-gray-600">Vancouver, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 40 Global</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">McGill University</h4>
            <p className="text-sm text-gray-600">Montreal, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 30 Global</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">McMaster University</h4>
            <p className="text-sm text-gray-600">Hamilton, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 100 Global</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">University of Waterloo</h4>
            <p className="text-sm text-gray-600">Waterloo, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top Engineering</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">Western University</h4>
            <p className="text-sm text-gray-600">London, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 200 Global</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">Queen's University</h4>
            <p className="text-sm text-gray-600">Kingston, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 200 Global</span>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow">
            <div className="bg-amber-100 w-12 h-12 rounded-lg mb-4 flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-lg mb-2">York University</h4>
            <p className="text-sm text-gray-600">Toronto, Canada</p>
            <span className="inline-block mt-2 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-semibold">Top 300 Global</span>
          </div>
        </div>

        {/* Global Recognition */}
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-3xl p-12 shadow-2xl">
          <h3 className="text-3xl font-bold mb-8 text-center">Recognized Globally</h3>
          <div className="grid md:grid-cols-4 gap-6 text-center">
            <div>
              <p className="text-5xl mb-2">🇨🇦</p>
              <p className="text-xl font-bold">Canada</p>
              <p className="text-blue-100">90+ Universities</p>
            </div>
            <div>
              <p className="text-5xl mb-2">🇺🇸</p>
              <p className="text-xl font-bold">United States</p>
              <p className="text-blue-100">200+ Universities</p>
            </div>
            <div>
              <p className="text-5xl mb-2">🇬🇧</p>
              <p className="text-xl font-bold">United Kingdom</p>
              <p className="text-blue-100">120+ Universities</p>
            </div>
            <div>
              <p className="text-5xl mb-2">🇦🇺</p>
              <p className="text-xl font-bold">Australia</p>
              <p className="text-blue-100">40+ Universities</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
